import { c as _c } from "react/compiler-runtime";
import { AlertSeverityType, AlertSizeType } from "@website/ui/alert";
import { SnackbarItem } from "@website/ui/snackbar/components";
import styles from "@website/ui/snackbar/snackbar.module.scss";
import { SnackbarContextType, SnackbarItemType, SnackbarProviderPropertiesType } from "@website/ui/snackbar/snackbar.types";
import { FC, JSX, createContext, useContext, useState } from "react";
export const SnackbarContext = createContext<SnackbarContextType>({
  enqueue: () => null
});
export const SnackbarProvider: FC<SnackbarProviderPropertiesType> = properties => {
  const $ = _c(17);
  const {
    children,
    queueSize: t0,
    duration: t1
  } = properties;
  const queueSize = t0 === undefined ? 1 : t0;
  const duration = t1 === undefined ? "short" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [queue, setQueue] = useState(t2);
  let t3;
  if ($[1] !== queueSize) {
    t3 = (title, severity, size, Action) => {
      const id = title + Date.now();
      setQueue(state => [...state.filter((_, index) => state.length < queueSize || index !== 0), {
        id,
        title,
        severity,
        size,
        Action
      }]);
      return id;
    };
    $[1] = queueSize;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const enqueue = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = id_0 => {
      setQueue(state_0 => state_0.filter(item => item.id !== id_0));
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const dequeue = t4;
  let t5;
  if ($[4] !== enqueue) {
    t5 = {
      enqueue,
      dequeue
    };
    $[4] = enqueue;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const value = t5;
  let t6;
  if ($[6] !== duration || $[7] !== queue) {
    let t7;
    if ($[9] !== duration) {
      t7 = (item_0, index_0) => <SnackbarItem Action={item_0.Action} dequeue={dequeue} duration={duration} id={item_0.id} index={index_0} key={item_0.id} severity={item_0.severity} size={item_0.size} title={item_0.title} />;
      $[9] = duration;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    t6 = queue.map(t7);
    $[6] = duration;
    $[7] = queue;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <div className={styles.container}>{t6}</div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== children || $[14] !== t7 || $[15] !== value) {
    t8 = <SnackbarContext.Provider value={value}>{children}{t7}</SnackbarContext.Provider>;
    $[13] = children;
    $[14] = t7;
    $[15] = value;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (context === undefined) {
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  }
  return context;
};